import { useCallback, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { api, ApiError } from "./api.js";
import type { Me } from "./types.js";
import Login from "./pages/Login.js";
import Shell from "./components/Shell.js";
import Dashboard from "./pages/Dashboard.js";
import Devices from "./pages/Devices.js";
import DeviceDetail from "./pages/DeviceDetail.js";
import Parts from "./pages/Parts.js";
import Orders from "./pages/Orders.js";
import Service from "./pages/Service.js";
import Prices from "./pages/Prices.js";
import Users from "./pages/Users.js";
import Crews from "./pages/Crews.js";
import Audit from "./pages/Audit.js";
import Certifications from "./pages/Certifications.js";
import ToastHost from "./components/ToastHost.js";

export default function App() {
  const [me, setMe] = useState<Me | null>(null);
  const [checked, setChecked] = useState(false);

  const refresh = useCallback(async () => {
    try {
      setMe(await api.get<Me>("/api/auth/me"));
    } catch (e) {
      if (!(e instanceof ApiError && e.status === 401)) console.error(e);
      setMe(null);
    } finally {
      setChecked(true);
    }
  }, []);

  useEffect(() => { void refresh(); }, [refresh]);

  if (!checked) return <div className="empty" style={{ paddingTop: 120 }}>Einen Moment…</div>;
  if (!me) return <><Login onSignedIn={setMe} /><ToastHost /></>;

  return (
    <>
      <Shell me={me} onSignedOut={() => setMe(null)}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/geraete" element={<Devices />} />
          <Route path="/geraete/:id" element={<DeviceDetail me={me} />} />
          <Route path="/service" element={<Service />} />
          <Route path="/ersatzteile" element={<Parts />} />
          <Route path="/bestellungen" element={<Orders />} />
          {me.role === "ADMIN" && <Route path="/preise" element={<Prices />} />}
          {me.role === "ADMIN" && <Route path="/benutzer" element={<Users />} />}
          {me.role === "ADMIN" && <Route path="/kolonnen" element={<Crews />} />}
          <Route path="/zertifizierungen" element={<Certifications me={me} />} />
          <Route path="/historie" element={<Audit />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
      <ToastHost />
    </>
  );
}
